import { Input } from "@/components/ui/input";
import { PALETTE, SWATCHES, splitColors } from "@/components/ColorChips";

// Tap swatches from the known palette to build a comma-separated color string,
// or type freely. Selected swatches stay highlighted; custom typed values are kept.
export const ColorSwatchPicker = ({ value, onChange, testId, placeholder }) => {
  const tokens = splitColors(value);
  const lower = tokens.map((t) => t.toLowerCase());
  const toggle = (name) => {
    const l = name.toLowerCase();
    const next = lower.includes(l)
      ? tokens.filter((t) => t.toLowerCase() !== l)
      : [...tokens, name];
    onChange(next.join(", "));
  };
  return (
    <div className="space-y-2" data-testid={testId}>
      <Input
        data-testid={`${testId}-input`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-12 border-zinc-800 bg-zinc-900 text-base"
      />
      <div className="flex flex-wrap gap-1.5">
        {PALETTE.map((name) => {
          const active = lower.includes(name.toLowerCase());
          return (
            <button
              key={name}
              type="button"
              data-testid={`${testId}-swatch-${name.toLowerCase()}`}
              aria-pressed={active}
              onClick={() => toggle(name)}
              title={name}
              className={`flex items-center gap-1.5 rounded-full border py-1 pl-1 pr-2.5 text-xs transition-colors duration-150 ${
                active
                  ? "border-indigo-400 bg-indigo-500/15 text-white"
                  : "border-zinc-800 bg-zinc-950 text-zinc-400 hover:border-zinc-600 hover:text-zinc-200"
              }`}
            >
              <span
                aria-hidden
                className="h-5 w-5 shrink-0 rounded-full ring-1 ring-black/30"
                style={{ background: SWATCHES[name.toLowerCase()] || "#71717a" }}
              />
              {name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ColorSwatchPicker;
